<div class="search-suggest-terms">
  <div class="d-flex justify-content-start headline">{{ 'suggest.terms.headline' | translate }}</div>
  <ul>
    @for (keyword of keywords() | slice : 0 : maxAutoSuggests(); track keyword) {
    <li>
      <button
        type="button"
        [innerHTML]="keyword.keyword | ishHighlight : (inputTerms$() | async)"
        (click)="submit(keyword.keyword)"
      ></button>
    </li>
    }
  </ul>
</div>
